import { Variant } from '@ts/variant';

export default function mapAndSortLightSourcesForSpecificVariant(
  lightSources: Variant[],
  recommendedLightsourcesIds?: string[],
): Variant[] {
  return lightSources
    ?.filter((ls) => ls.stockStatus !== 'OutOfStock')
    .map((lightsource): Variant => {
      const isRecommended =
        recommendedLightsourcesIds?.some((id) => id === lightsource.id) ??
        false;

      return {
        ...lightsource,
        isRecommended,
      };
    })
    .sort((prevVariant, newVariant) => {
      if (prevVariant.isRecommended && newVariant.isRecommended) {
        return prevVariant.se_Price - newVariant.se_Price;
      }
      if (!prevVariant.isRecommended && !newVariant.isRecommended) {
        return prevVariant.se_Price - newVariant.se_Price;
      }
      if (prevVariant.isRecommended && !newVariant.isRecommended) {
        return -1;
      }
      if (!prevVariant.isRecommended && newVariant.isRecommended) {
        return 1;
      }
      return 0;
    });
}
